document.addEventListener("DOMContentLoaded", async function () {
  const req = await fetch(
    `${window.location.href.split("?")[0]}?view=series-metafields-json`
  );
  const metafields = await req.json();
  const variant_description = document.querySelector(
    "[series-variant-description]"
  );
  const accordion = [
    "specifications",
    "therapies",
    "things_to_consider",
    "recommended_uses",
    "instructional_guides"
  ];
  const accordion_items = accordion.map((item) =>
    document.querySelector(
      `[series-variant-${item}] [data-collapsible-content]`
    )
  );

  window.addEventListener("variant:changed", (e) => {
    const variant = e.detail.variant;
    const variant_id = variant.id;
    const { metafields: variant_metafields } = metafields.variants[variant_id];
    const { inventory_policy, inventory_quantity } =
      metafields.variants[variant_id];

    const isBackorder = inventory_policy !== "deny" && inventory_quantity < 1;

    const form = document.getElementById('AddToCartForm');
    
    if (isBackorder) {
      form.classList.add('show-backorder-notice');
    } else {
      form.classList.remove('show-backorder-notice');
    }

    if (variant_metafields) {
      if (variant_description && variant_metafields.description) {
        variant_description.innerHTML = variant_metafields.description;
      }
      accordion_items.forEach((item, index) => {
        if (item && variant_metafields[accordion[index]]) {
          item.innerHTML = variant_metafields[accordion[index]];
          item
            .closest(".collapsible-tab")
            .querySelector("collapsible-button")
            .resetHeight();
        }
      });

      const addToCartButton = document.getElementById("AddToCart");
      const dinamicAddToCartBtn = document.querySelectorAll(
        ".sticky-add__btn #AddToCart"
      );

      if (addToCartButton && variant.available) {
        addToCartButton.querySelector("span:last-child").innerText = isBackorder
          ? "Backorder"
          : "Add to Cart";
      }

      if (dinamicAddToCartBtn.length > 0 && variant.available) {
        dinamicAddToCartBtn.forEach((btn) => {
          btn.querySelector("span:nth-child(2)").innerText = isBackorder
            ? "Backorder"
            : "Add to Cart";
        });
      }

      if (!variant.available) {
        const addToCartButton = document.getElementById("AddToCart");
        const dinamicAddToCartBtn = document.querySelectorAll(
          ".sticky-add__btn #AddToCart"
        );

        if (addToCartButton) {
          addToCartButton.querySelector("span:last-child").innerText =
            "Sold Out";
        }

        if (dinamicAddToCartBtn.length > 0) {
          dinamicAddToCartBtn.forEach((btn) => {
            btn.querySelector("span:nth-child(2)").innerText = "Sold Out";
          });
        }
      }
    }
  });
  // Model or Size
  let mainOption;
  if (FMproduct.options.includes("Model")) {
    mainOption = "Model";
  } else if (FMproduct.options.includes("Voltage")) {
    mainOption = "Voltage";
  }

  const mainOptionNumber = FMproduct.options.indexOf(mainOption) + 1;
  const option2Number = mainOptionNumber === 1 ? 2 : 1;

  const handleOption1Change = (e) => {
    if (!mainOption) return;
    try {
      const selectedMainOptions = document.querySelectorAll(
        `.swatch-element.variant-swatch[data-option='${mainOption}'] input`
      );

      const selectedMainOption = Array.from(selectedMainOptions).find(
        (option) => option.checked
      )?.value;

      const allVariants = FMproduct.variants;

      const option1Variants = allVariants.filter(
        (v) => v[`option${mainOptionNumber}`] === selectedMainOption
      );

      const option2SwatchItems = document.querySelectorAll(
        `.swatch-element:has(input[name='option-${option2Number}'])`
      );
      option2SwatchItems.forEach((el) => {
        const option2Value = el.querySelector("input").value;

        const isAvailable = option1Variants.some(
          (v) => v.available && v[`option${option2Number}`] === option2Value
        );
        el.classList.toggle("soldout", !isAvailable);
      });
    } catch (error) {
      console.error("Error in handleOption1Change:", error);
    }
  };

  const option1Inputs = document.querySelectorAll(
    `.swatch-items-wrapper input[name='option-${mainOptionNumber}']`
  );

  option1Inputs.forEach((input) => {
    input.addEventListener("change", handleOption1Change);
  });
  window.addEventListener("variant:changed", handleOption1Change);
});

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const mainImage = document.querySelector(
      ".product-medias__main .swiper-container"
    );

    const setMaxHeight = () => {
      const thumbnails = document.querySelector(".product-medias__thumbnails");
      if (thumbnails) {
        thumbnails.style.maxHeight = `${mainImage.offsetHeight}px`;
      }
    };

    setMaxHeight();

    window.addEventListener("resize", () => {
      setMaxHeight();
    });
  }, 1000);
});
// document.addEventListener("DOMContentLoaded", function () {
//   const variantInput = document.querySelector("form [name='id']");
//   const dropdown = document.querySelectorAll('.wetheme-dropdown');
//   console.log(dropdown);
  
//   variantInput.addEventListener("change", function () {
//     const variantId = parseInt(this.value);
//     const variant = FMproduct.variants.find(v => v.id === variantId);
//     if (!variant) return;
//     const priceElement = document.getElementById("ProductPrice");
//     if (priceElement) {
//       priceElement.innerText = formatMoney(variant.price);
//     }
//   });
// });
